module.exports = __webpack_public_path__ + "static/media/bannerbackground.e0679251.png";